module.exports = __webpack_public_path__ + "img/imac.b71f77ea.png";